// Common money rendering for the legacy shared helper and source-aware adapters.
// Callers own missing-value and currency selection policy; this function never reads a store.
export const formatMoney = (value, currencyCode, options = {}) => {
  const locale = options.locale || 'en-US';
  let precision = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  if (currencyCode) {
    try {
      const defaults = new Intl.NumberFormat(locale, {
        style: 'currency', currency: currencyCode,
      }).resolvedOptions();
      precision = {
        minimumFractionDigits: defaults.minimumFractionDigits,
        maximumFractionDigits: defaults.maximumFractionDigits,
      };
    } catch (error) {
      if (!options.fallbackInvalidCurrency) throw error;
    }
  }
  let maximumOverridden = false;
  for (const key of ['minimumFractionDigits', 'maximumFractionDigits']) {
    const digits = options[key];
    if (Number.isInteger(digits) && digits >= 0 && digits <= 20) {
      precision[key] = digits;
      if (key === 'maximumFractionDigits') maximumOverridden = true;
    }
  }
  if (precision.minimumFractionDigits > precision.maximumFractionDigits) {
    if (maximumOverridden) precision.minimumFractionDigits = precision.maximumFractionDigits;
    else precision.maximumFractionDigits = precision.minimumFractionDigits;
  }
  const sign = options.signed && value > 0 ? '+' : '';
  if (['symbol', 'narrowSymbol'].includes(options.currencyDisplay) && currencyCode) {
    try {
      return sign + new Intl.NumberFormat(locale, {
        style: 'currency', currency: currencyCode,
        currencyDisplay: options.currencyDisplay, ...precision,
      }).format(value);
    } catch (error) {
      if (!options.fallbackInvalidCurrency) throw error;
    }
  }
  const amount = sign + new Intl.NumberFormat(locale, precision).format(value);
  if (options.currencyDisplay === 'amount') return amount;
  const unit = currencyCode || options.unknownCurrencyLabel;
  return unit ? `${amount} ${unit}` : amount;
};
